import {
  BaseWidgetProperties,
  ButtonSizeOptions,
  ButtonTypes,
  GridPosition,
} from '@finxone-platform/shared/sys-config-types';
import { BackButtonWidgetBuilderCssConfig } from '../../../../widgets';
import { BackButtonWidgetBuilder } from '../../../../widgets/example-builder';
import {
  commonNotificationDescriptionTextWidget,
  commonNotificationHeaderTextWidget,
  commonNotificationImageWidget,
  commonTextWidgetConversionDetail,
} from '../utils/notification-utils';

export const notificationExchangeFailedWidgets = [
  commonNotificationImageWidget({
    configDisplayName: 'Image Widget: Failed Icon',
    attributes: {
      widgetProperties: {
        textContent: '',
        imageAssetUrl: 'assets/images/payment-decline.svg',
      } as BaseWidgetProperties,
    },
    gridPosition: { y: 0, rows: 2 } as GridPosition,
  }),
  commonNotificationHeaderTextWidget({
    text: '<div class="w-100"><p class="m-0">Conversion Failed</p></div>',
    configDisplayName: 'Exchange Failed Header',
    css_config: {
      color: 'var(--color-error)',
      textAlignment: 'center',
      justifyContent: 'center',
      fontSize: 20,
      isTextBold: 'bold',
    },
    gridPosition: { y: 2, rows: 3 } as GridPosition,
  }),
  commonNotificationDescriptionTextWidget({
    text: '<div class="w-100"><p>Your transaction has been completed successfully. If you have any questions or concerns, please feel free to contact our customer support.</p></div>',
    configDisplayName: 'Description Text',
    gridPosition: { y: 5, rows: 6 } as GridPosition,
  }),
  ...commonTextWidgetConversionDetail,
  new BackButtonWidgetBuilder()
    .defaultBackButton()
    .cssConfig(BackButtonWidgetBuilderCssConfig)
    .gridPosition({ y: 45, rows: 2, cols: 15 } as GridPosition)
    .isRemovable(true)
    .setGlobalStylingClass(true, `${ButtonTypes.SECONDARY} ${ButtonSizeOptions.FULL_WIDTH}`)
    .build(),
];
